import { render, staticRenderFns } from "./ClickableOffersTable.vue?vue&type=template&id=fd9e25d0"
import script from "./ClickableOffersTable.vue?vue&type=script&lang=js"
export * from "./ClickableOffersTable.vue?vue&type=script&lang=js"
import style0 from "./ClickableOffersTable.vue?vue&type=style&index=0&id=fd9e25d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports